import React from 'react';
export function KitContentsSection() {
  const contents = [{
    emoji: '🎒',
    title: '6 Tomos de Primaria',
    desc: 'Actividades progresivas de 1° a 6° grado'
  }, {
    emoji: '🏫',
    title: '6 Tomos de Secundaria',
    desc: 'Contenido desde 1er a 6to año de secundaria'
  }, {
    emoji: '📝',
    title: 'Actividades Paso a Paso',
    desc: 'Instrucciones claras para cada clase'
  }, {
    emoji: '✅',
    title: 'Evaluaciones y Rúbricas',
    desc: 'Sistemas de calificación objetivos'
  }, {
    emoji: '🎵',
    title: 'Técnicas Musicales',
    desc: 'Ritmo, melodía, armonía y ensamble'
  }, {
    emoji: '🏛️',
    title: 'Historia Integrada',
    desc: 'Contexto musical de forma entretenida'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-16" data-id="element-92">
          📦 ¿Qué contiene el Pack Música Lista?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-93">
          {contents.map((item, i) => <div key={i} className="bg-white rounded-3xl p-8 text-center border border-brand-creamDark/50 shadow-sm hover:shadow-md transition-shadow" data-id="element-94">
              <div className="text-4xl mb-4" data-id="element-95">{item.emoji}</div>
              <h3 className="text-xl font-serif font-bold text-brand-text mb-2" data-id="element-96">
                {item.title}
              </h3>
              <p className="text-brand-gray text-sm" data-id="element-97">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}